import { mixins, Text } from "@fastly/consistently"
import styled, { keyframes, css } from "styled-components"

const { marginInline } = mixins

export const StyledH2 = styled.h2`
  text-align: center;

  @media (min-width: 992px) {
    text-align: left;
  }
`
export const StyledCustomerCallOut = styled.section`
  background: var(--grey-80);
  color: white;
  border-radius: 16px;
  padding: ${({ theme }) => theme.space.xl} ${({ theme }) => theme.space["4xl"]};
  @media (min-width: 544px) {
    padding: 0 ${({ theme }) => theme.space["8xl"]} ${({ theme }) => theme.space.xl};
  }
  max-width: initial;
  position: relative;
  text-align: center;
  margin: ${({ theme }) => theme.space.md} auto;
  max-width: 940px;

  .carouselLogo {
    display: flex;
    align-items: center;
    padding: 1.6rem;
    background: var(--grey-20);
    border-radius: 8px;
    position: relative;
    top: -18px;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: ${({ theme }) => theme.space.xl};
    max-width: 224px;
    max-height: 80px;
    object-fit: contain;

    img {
      width: auto;
      max-height: 40px;
      align-self: center;
      margin: 0 auto;
    }
  }

  blockquote {
    font: var(--text-md);
    line-height: 1.4;
    max-width: 544px;
    ${marginInline("auto")};
  }

  .name {
    font: var(--text-sm);
    font-weight: bold;
    color: var(--grey-40);
  }

  .title {
    font: var(--text-sm);
    color: var(--grey-40);
  }

  .cta {
    margin-top: ${({ theme }) => theme.space.xl};
  }
`

export const StyledPreBenefits = styled.div`
  p {
    font: var(--text-h4);
    font-weight: normal;
    line-height: 140%;
  }
  ${(props) =>
    props.paragraphs &&
    `
    p {
      font: var(--text-md);
    }

    p:nth-of-type(1) {
      font: var(--text-h4);
      font-weight: normal;
      line-height: 140%;
    }
  `};
`

export const StyledProfessionalServices = styled.div`
  width: 100%;
  background: var(--white);
  box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  padding: ${({ theme }) =>
    css`
      ${theme.space.xl} ${theme.space.md} ${theme.space.xl} ${theme.space.md}
    `};
  max-width: 1134px;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: ${({ theme }) => theme.space.xl};
    grid-column-gap: ${({ theme }) => theme.space["4xl"]};
    grid-auto-flow: dense;
  }

  @media (min-width: 1200px) {
    padding: ${({ theme }) =>
      css`
        ${theme.space.xl} ${theme.space["4xl"]}
      `};
  }

  & > div:nth-child(1) {
    width: 90%;

    @media (min-width: 1024px) {
      width: 95%;
      align-self: center;
    }

    h4 {
      margin-left: 2.5rem;
      position: relative;
      margin-bottom: 20px;
      margin-bottom: ${({ theme }) => theme.space.lg};
      display: flex;
      white-space: pre;

      &::before {
        content: "";
        background: ${(props) => props.iconSrc && `url(${props.iconSrc}) no-repeat center`};
        width: 28px;
        height: 32px;
        position: absolute;
        margin-left: -2.5rem;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    p {
      font-weight: 500;
      font-size: 15px;
      line-height: 140%;
      letter-spacing: -0.144px;
      color: var(--grey-70);

      sup {
        font-size: 10px;
      }
    }

    > ul {
      list-style: none;
      padding-left: ${({ theme }) => theme.space.lg};

      @media (min-width: 1200px) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: ${({ theme }) => theme.space.lg};
      }

      li {
        position: relative;
        padding-right: 1rem;

        p {
          display: inline-block;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        &::before {
          content: "";
          display: inline-block;
          background-color: ${(props) => props.color && `var(--${props.color})`};
          height: 0.45rem;
          width: 0.45rem;
          border-radius: 1rem;
          margin-left: -1.5em;
          position: absolute;
          top: 20%;
          left: 0;
        }
      }

      li:last-of-type {
        &::before {
          top: 30%;
        }

        p {
          margin-bottom: 0;
        }
      }
    }
  }
`

export const StyledHeroCompany = styled.div`
  width: 100%;
  padding: 0 1rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
`

export const StyledIntroHeroCompany = styled.div`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.space.lg};

  p {
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: var(--grey-60);
    font-weight: 700;

    @media (min-width: 1024px) {
      font-size: 15px;
    }
  }
`
export const StyledHeroCompanyList = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: repeat(12, 1fr);
  grid-row-gap: ${({ theme }) => theme.space.xl};

  @media (min-width: 768px) {
    display: flex;
    justify-content: space-around;
    max-width: 750px;
    margin: 0 auto;
  }

  img {
    width: auto;
    height: 30px;
  }

  img:nth-of-type(1) {
    grid-row: 1 / 1;
    grid-column: 1 / 4;
    justify-self: end;
  }

  img:nth-of-type(2) {
    grid-row: 1 / 1;
    grid-column: 5 / -5;
    justify-self: center;
  }

  img:nth-of-type(3) {
    grid-row: 1 / 1;
    grid-column: 10 / -2;
    justify-self: end;
  }

  img:nth-of-type(4) {
    grid-row: 2 / 2;
    grid-column: 1 / -8;
    justify-self: center;
  }

  img:nth-of-type(5) {
    grid-row: 2 / 2;
    grid-column: -6 / -1;
    justify-self: start;
  }
`
export const StyledCenterText = styled.section`
  text-align: center;
  max-width: 640px;
  margin: 0 1rem 3rem 1rem;

  @media (min-width: 768px) {
    margin: 0 auto 3rem auto;
  }

  & h3 {
    font: var(--h2);
    margin: 0 1.1rem;
  }
`

/* Performance at scale */
export const StyledPerfWrapper = styled.section`
  display: flex;
  flex-direction: column-reverse;
  max-width: 1140px;
  margin: 0 1rem 0 1rem;
  position: relative;

  @media (min-width: 768px) {
    flex-direction: row-reverse;
    margin: ${({ theme }) => css`0 ${theme.space.lg} 0 ${theme.space.lg}`};
  }

  @media (min-width: 1200px) {
    margin: 0 auto;
  }
`

export const StyledPerfText = styled.div(
  ({ theme, p, maxWidth }) => css`
    background-color: var(--grey-80);
    color: var(--grey-40);
    padding: 6.5rem 1.1rem 3rem;
    border-radius: ${theme.space.md};
    transform: translateY(-2.5rem);
    ${p?.sm && `padding: ${p.sm}`};

    & h2 {
      color: var(--white);
      margin: 0 1.33rem 2rem 1.33rem;
    }

    & ul {
      list-style: none;
    }

    & li {
      margin-bottom: ${theme.space.md};
    }

    & ul li p:first-of-type {
      color: var(--white);
      letter-spacing: -0.144px;
      margin-bottom: ${theme.space.sx};
      position: relative;

      &:before {
        content: "✓";
        background-size: contain;
        background-repeat: no-repeat;
        color: var(--green);
        position: absolute;
        height: ${theme.space.lg};
        width: ${theme.space.lg};
        left: 0;
        transform: translateX(-1.6875rem);
      }
    }

    & a {
      margin: 1rem 0 0 1.5rem;
    }

    & p:first-of-type {
      margin: 0 ${theme.space.lg};
    }

    @media (min-width: ${theme.breakpoints.md}) {
      padding: ${p?.md ? p.md : "3.66rem 2.1rem 6.4rem 13rem;"};
      max-width: ${maxWidth?.md ? maxWidth.md : "37.625rem"};
    }

    @media (min-width: ${theme.breakpoints.xl}) {
      padding: ${p?.xl ? p.xl : "6.5rem 6rem 14.5rem 19rem"};
      max-width: ${maxWidth?.xl ? maxWidth.xl : "52.6875rem"};
    }
  `
)

export const StyledPerfImage = styled.div(
  ({ theme, objectPosition }) => css`
    width: calc(100% - 50px);
    border-radius: ${theme.space.md};
    margin: 0 auto;
    position: relative;
    z-index: 2;

    &:before {
      content: "";
      border: 1px solid var(--green);
      border-radius: ${theme.space.md};
      position: absolute;
      height: calc(100% + 2.5rem);
      width: 200%;
      right: 1.3125rem;
      top: -${theme.space.md};
      z-index: -1;

      @media (min-width: ${theme.breakpoints.md}) {
        height: calc(100% + 100px);
        right: 0;
        top: 0;
        transform: translate(-8%, -7%);
      }

      @media (min-width: ${theme.breakpoints.lg}) {
        height: calc(100% + 6.375rem);
        transform: translate(-8%, -6.5%);
      }
    }

    & img {
      box-shadow: 0.6rem 0.6rem var(--grey-80);
      border-radius: ${theme.space.md};
      object-fit: cover;
      ${objectPosition?.sm && `object-position: ${objectPosition.sm}`};
      z-index: 3;

      @media (min-width: ${theme.breakpoints.md}) {
        box-shadow: 1.1rem 1.1rem var(--grey-80);
        object-position: ${objectPosition?.md ? objectPosition.md : "3.4375rem"};
      }

      @media (min-width: ${theme.breakpoints.lg}) {
        box-shadow: 1.5rem 1.5rem var(--grey-80);
        object-position: ${objectPosition?.lg ? objectPosition.lg : "center"};
      }
    }

    @media (min-width: ${theme.breakpoints.md}) {
      min-width: 22.625rem;
      min-height: 24.125rem;
      max-width: 30.4375rem;
      max-height: 32.5rem;
      width: auto;
      height: auto;
      margin: 0;
      position: absolute;
      right: 0;
      transform: translate(-100%, -1rem);
      z-index: 1;
    }

    @media (min-width: ${theme.breakpoints.lg}) {
      height: 32.5rem;
    }

    @media (min-width: ${theme.breakpoints.xl}) {
      left: 0;
      top: 0;
      transform: translate(0, 10%);
    }
  `
)

/* Overview */
export const StyledOverview = styled.section`
  background-color: var(--grey-20);
  padding: 6rem 0;

  .icon {
    width: 52px;
    height: 52px;
    background-image: ${(props) => props.iconSrc && `url(${props.iconSrc})`};
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin-bottom: 1rem;
  }
`

export const StyledOverviewItem = styled.div`
  margin-bottom: 3rem;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  p {
    line-height: 140%;
    letter-spacing: -0.144px;
    color: var(--grey-70);
  }
`

export const StyledBoxShadow = styled.div`
  box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.06);
  padding: 3rem 2rem;
  background-color: ${(props) => props.background && props.background};
  border-radius: ${(props) => props.radius === true && `16px`};

  @media (min-width: 768px) {
    padding: 5rem 1rem;
  }

  @media (min-width: 1200px) {
    padding: 3rem 1rem;
  }
`

/* Serverless map */
export const StyledToggleSwitchWrapper = styled.div`
  background: #182931;
  box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  padding: 1.5rem;
  width: 260px;
  height: 149px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  position: absolute;
  left: 50%;
  right: 50%;
  transform: translate(-50%, -50%);

  @media (min-width: 768px) {
    transform: translate(16%, -28%);
  }

  p {
    color: white;
    margin-bottom: 0;
    text-align: center;
  }
`

export const StyledToggleSwitch = styled.div`
  background: #000000;
  border-radius: 20px;
  width: 186px;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.8rem 0 0.5rem;

  p {
    color: white;
    font-weight: 700;
  }

  & div {
    background: #2d3741;
    border: 1px solid #434e58;
    box-sizing: border-box;
    border-radius: 11.5px;
    width: 40px;
    height: 23px;
    position: relative;

    & ::after {
      content: "";
      position: absolute;
      width: 17px;
      height: 17px;
      border-radius: 50%;
      background-color: ${(props) => (props.toggleStatus === true ? `var(--green-light);` : `var(--grey-40);`)};
      top: 2px;
      left: ${(props) => (props.toggleStatus === true ? `19px` : `3px`)};
      transition: all 0.35s;
    }
  }
`

export const StyledMapEgde = styled.div`
  background: ${(props) =>
    props.toggleStatus === null && `url(${props.off}) no-repeat center`}; // first frame map off, toggleStatus = null
  height: 553px;
  position: relative;
  ${(props) =>
    props.toggleStatus !== null &&
    css`
      background: ${(props) => (props.toggleStatus === false ? `url(${props.baseMap}) no-repeat center` : "")};

      &::before {
        content: "";
        background: ${(props) =>
          props.toggleStatus === false ? `url(${props.off}) no-repeat center` : `url(${props.on}) no-repeat center`};
        height: 553px;
        width: 100%;
        transition: all 0.3s;
        position: absolute;
        left: 0;
        top: 0;
        animation: ${(props) =>
          props.toggleStatus === false &&
          css`
            ${expandLinesOfMapOFF} 3.5s
          `};
      }

      @media (min-width: 768px) {
        &::before {
          animation: ${(props) =>
            props.toggleStatus === false &&
            css`
              ${expandLinesOfMapOFFLg} 3.5s
            `};
        }
      }
    `}
`

const expandLinesOfMapOFF = keyframes`
  0% {
    clip-path: circle(100%);
  }
  40% {
    clip-path: circle(0% at 43% 33%);
  }
  100% {
    clip-path: circle(100%);
  }
`

const expandLinesOfMapOFFLg = keyframes`
  0% {
    clip-path: circle(100%);
  }
  40% {
    clip-path: circle(0% at 48% 33%);
  }
  100% {
    clip-path: circle(100%);
  }
`

/* StyledText */
export const StyledText = styled.div`
  display: flex;
  position: relative;

  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}

  ${(props) =>
    props.flexDirection &&
    css`
       {
        flex-direction: ${props.flexDirection};
      }
    `}
`

export const IntroText = styled(Text)`
  p {
    font-size: inherit;
    margin-bottom: ${({ theme }) => theme.space["4xl"]};
  }
  p:empty {
    display: none;
  }
  a + a {
    margin-left: ${({ theme }) => theme.space.md};
  }
`
